import { TokenHistoryLabel } from "kadow-jetpack-model";
import { tt } from "../i18n/i18n";

export default function (type: TokenHistoryLabel): string {
  switch (type) {
    case TokenHistoryLabel.Facebook:
    case TokenHistoryLabel.FacebookS:
      return tt("cta_facebook_like");

    case TokenHistoryLabel.Instagram:
    case TokenHistoryLabel.InstagramS:
      return tt("cta_instagram_check_out");

    case TokenHistoryLabel.EmailOptIn:
      return tt("cta_newsletter_subscribe");

    case TokenHistoryLabel.Google:
      return tt("cta_leave_review");

    case TokenHistoryLabel.OnlineOrder:
      return tt("cta_place_online_order");

    case TokenHistoryLabel.Receipt:
      return tt("cta_buy_and_photo");

    case TokenHistoryLabel.Deliveroo:
      return tt("cta_rate_deliveroo");

    case TokenHistoryLabel.UberEats:
      return tt("cta_rate_ubereats");

    case TokenHistoryLabel.UberEatsDeliveroo:
      return tt("cta_rate_ubereats_or_deliveroo");

    case TokenHistoryLabel.Feedback:
      return tt("cta_give_feedback_title");

    case TokenHistoryLabel.NPS:
      return tt("cta_rate_1_to_10");

    case TokenHistoryLabel.Sponsorship:
      return tt("cta_sponsor_friend");

    case TokenHistoryLabel.TikTok:
      return tt("cta_follow_tiktok");

    case TokenHistoryLabel.BAO:
      return tt("cta_send_gift_card");

    case TokenHistoryLabel.TripAdvisor:
      return tt("cta_tripadvisor_review");

    case TokenHistoryLabel.DownloadApp:
      return tt("cta_download_app");

    case TokenHistoryLabel.Custom:
      return tt("cta_discover_website");

    case TokenHistoryLabel.FirstName:
      return tt("cta_leave_first_name");

    case TokenHistoryLabel.Phone:
      return tt("cta_leave_phone");

    case TokenHistoryLabel.Birthday:
      return tt("cta_give_birth_date");

    case TokenHistoryLabel.SnapChat:
      return tt("cta_follow_snapchat");

    case TokenHistoryLabel.PostalCode:
      return tt("cta_leave_postal_code");

    case TokenHistoryLabel.IGStory:
      return tt("cta_instagram_story");

    case TokenHistoryLabel.Share:
      return tt("cta_play_with_friends");

    case TokenHistoryLabel.Prospecting:
      return tt("cta_lets_meet");

    case TokenHistoryLabel.B2BSimulator:
      return tt("cta_simulate_performance");

    case TokenHistoryLabel.Whatsapp:
      return tt("cta_whatsapp_hello");

    case TokenHistoryLabel.ViewLocation:
      return tt("cta_visualize_location");

    case TokenHistoryLabel.CustomForm:
      return tt("cta_custom_form");

    case TokenHistoryLabel.CheckIn:
      return tt("cta_checkin");

    case TokenHistoryLabel.WhatsappGroup:
      return tt("cta_whatsapp_group");

    case TokenHistoryLabel.Photo:
      return tt("cta_photo");

    case TokenHistoryLabel.CustomerOfMonthReward:
      return tt("cta_customer_of_month_reward");

    case TokenHistoryLabel.LoyaltyReward:
      return tt("cta_loyalty_reward");

    case TokenHistoryLabel.Init:
    case TokenHistoryLabel.Game:
    case TokenHistoryLabel.Registration:
    case TokenHistoryLabel.FreeTokens:
    case TokenHistoryLabel.MonthlyLottery:
    case TokenHistoryLabel.BAORedeem:
    case TokenHistoryLabel.LoyaltyReward:
    case TokenHistoryLabel.Photo:
    case TokenHistoryLabel.CustomerOfMonthReward:
      return "";
  }
}
